// Copy for the processing_error codes ImageProcessingJob can set on an upload.
// The 20,000 px figure mirrors ImageProcessingJob::MAX_DIMENSION_PX.
export const PROCESSING_ERRORS = {
  invalid_dimensions: "This image's dimensions can't be used. Images can be up to 20,000 px on each side. Export it at 300 DPI at the size you want printed, then upload again.",
  corrupt_file: 'This file could not be processed. It may be corrupted.',
  unsupported_format: 'This file format is not supported after upload.',
  processing_error: 'An unexpected error occurred while processing this file.',
}
